import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { UserManagementService } from 'src/app/Service/user-management.service';

@Component({
  selector: 'app-view-detail',
  templateUrl: './view-detail.component.html',
  styleUrls: ['./view-detail.component.scss'],
})
export class ViewDetailComponent implements OnInit {
  food: string;
  datashowtrader = false;
  datashowfarmer = false;
  documentStatus;
  customerid;
  avtar = false;
  userdata;
  latestTicketID;
  imageList: any = [];
  records: any = [];
  userName;
  userID;
  userComment;
  district;
  state;
  mobileNo;
  sfUserID;
  ticketId;
  postedDate;

  // companyname;  mandi; personName; phoneNo; role; states; district; taluk; numberOfTrees; treeType;resultdata;
  // commTradeInterest; reqFrequency; aboutUs; profile_Image; address;email;village;
  datashow = true;
  Viewprofile = false;
  spinner: any;
  constructor(
    public dialogRef: MatDialogRef<ViewDetailComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public _userService: UserManagementService
  ) {}
  resultdata;
  ngOnInit(): void {
    var value = {
      Id: this.data.name,
    };
    /*Get user profile model data */
    this._userService.getTicketDetail(value.Id).subscribe((data) => {
      this.userdata = data;
      this.resultdata = this.userdata.result.data;
      if (data['result'].data) {
        // this.latestTicketId = data['result'].data.latestTicketID
        // if(this.latestTicketId=== value.ticketId){
        //   this.toastr.success(`Your Latest Ticket Id :${this.latestTicketId}`, 'Info', {
        //     timeOut: 3000,
        //   });
      }

      //     this.datashowtrader = false;
      //     this.datashow = false;
      //     this.datashowfarmer = true;
      //     this.avtar = false;
      //     this.Viewprofile = true;
      //     if (this.resultdata.role == "TRADER") {
      //       this.datashowtrader = true;
      //       this.datashowfarmer = false;
      //     }
      if (this.resultdata.ImageList == null) {
        this.avtar = true;
      }
      this.latestTicketID = this.resultdata.latestTicketID;
      this.imageList.push(
        this.resultdata.attachment1__c,
        this.resultdata.attachment2__c,
        this.resultdata.attachment3__c
      );

      this.records = this.resultdata.records;
      // this.imageList = this.resultdata.imageList;
      this.userName = this.resultdata.userName;
      this.userID = this.resultdata.userID;
      this.userComment = this.resultdata.userComment;
      this.district = this.resultdata.district;
      this.state = this.resultdata.state;
      this.mobileNo = this.resultdata.mobileNo;
      this.sfUserID = this.resultdata.sfUserID;
      this.ticketId = this.resultdata.ticketId;
      this.postedDate = this.resultdata.postedDate;
    });
    /*Get user profile model data */
  }

  onNoClick(): void {
    this.dialogRef.close({});
  }
}
